import { render, staticRenderFns } from "./IpPop.vue?vue&type=template&id=5f7ccd79&scoped=true"
import script from "./IpPop.vue?vue&type=script&lang=js"
export * from "./IpPop.vue?vue&type=script&lang=js"
import style0 from "./IpPop.vue?vue&type=style&index=0&id=5f7ccd79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ccd79",
  null
  
)

export default component.exports